
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ReagentPageHeaderProps {
  showFilters: boolean;
  toggleFilters: () => void;
  handleRefresh: () => void;
  isRetrying: boolean;
}

const ReagentPageHeader = ({ 
  showFilters, 
  toggleFilters, 
  handleRefresh, 
  isRetrying 
}: ReagentPageHeaderProps) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
      <h1 className="text-3xl font-bold mb-4 md:mb-0">Browse Reagents</h1>
      <div className="flex gap-2">
        <Button
          variant="outline"
          className="mb-4 md:mb-0 md:hidden"
          onClick={toggleFilters}
        >
          <SlidersHorizontal className="h-4 w-4 mr-2" />
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
        
        <Button
          variant="outline"
          onClick={handleRefresh}
          disabled={isRetrying}
        >
          {isRetrying ? "Refreshing..." : "Refresh"}
        </Button>
      </div>
    </div>
  );
};

export default ReagentPageHeader;
